var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "community-questions-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2643 2C13.1627 2 14.9833 2.75413 16.3257 4.0965C17.6681 5.43886 18.4222 7.2595 18.4222 9.15789C18.4222 11.0563 17.6681 12.8769 16.3257 14.2193C14.9833 15.5617 13.1627 16.3158 11.2643 16.3158H10.8432V17.1495C10.8432 17.2612 10.8212 17.3719 10.7784 17.4752C10.7356 17.5784 10.6729 17.6722 10.5938 17.7512C10.5148 17.8302 10.4209 17.8928 10.3176 17.9355C10.2143 17.9782 10.1036 18.0001 9.99187 18C7.92029 17.9983 5.82176 17.3069 4.22934 15.8914C2.6226 14.4615 1.58176 12.3368 1.58008 9.58653V9.15789C1.58008 7.2595 2.33421 5.43886 3.67658 4.0965C5.01894 2.75413 6.83958 2 8.73797 2H11.2643ZM7.05376 7.89474C6.71875 7.89474 6.39746 8.02782 6.16057 8.26471C5.92369 8.5016 5.7906 8.82288 5.7906 9.15789C5.7906 9.49291 5.92369 9.81419 6.16057 10.0511C6.39746 10.288 6.71875 10.4211 7.05376 10.4211C7.38877 10.4211 7.71006 10.288 7.94695 10.0511C8.18384 9.81419 8.31692 9.49291 8.31692 9.15789C8.31692 8.82288 8.18384 8.5016 7.94695 8.26471C7.71006 8.02782 7.38877 7.89474 7.05376 7.89474ZM12.9485 7.89474C12.6135 7.89474 12.2922 8.02782 12.0553 8.26471C11.8184 8.5016 11.6853 8.82288 11.6853 9.15789C11.6853 9.49291 11.8184 9.81419 12.0553 10.0511C12.2922 10.288 12.6135 10.4211 12.9485 10.4211C13.2835 10.4211 13.6048 10.288 13.8417 10.0511C14.0786 9.81419 14.2117 9.49291 14.2117 9.15789C14.2117 8.82288 14.0786 8.5016 13.8417 8.26471C13.6048 8.02782 13.2835 7.89474 12.9485 7.89474Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityQuestions);
export default __webpack_public_path__ + "static/media/CommunityQuestions.909c6a96504b4594c84ffcd2e46afacc.svg";
export { ForwardRef as ReactComponent };